import MarketPlace1 from "@assets/KPMG/MarketPlace1.svg";
import MarketPlace2 from "@assets/KPMG/MarketPlace2.svg";

export const mockData: any = {
  faqList: [
    {
      sNo: "01",
      question: "What are the major infrastructure projects driving Singapore development?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      sNo: "02",
      question: "How is sustainability being integrated into infrastructure planning and execution",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      sNo: "03",
      question: "What financing products are supporting green and innovative infrastructure",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      sNo: "04",
      question: "How is digital infrastructure evolving to meet growing demands",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      sNo: "05",
      question: "What are the key challenges and opportunities in building sustainable infrastructure",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
  ],
};
